import { OriginatorsListItemResponse } from "../../../common/api/delivery-api/originators/GetOriginatorsListResponse";

export interface OriginatorListingItem {
    id: string;
    name: string;
    updatedDate: Date;
    isModified?: boolean;
}

export const mapToOriginatorListingItem = (item: OriginatorsListItemResponse): OriginatorListingItem => {
    return {
        id: item.id,
        name: item.name,
        updatedDate: new Date(item.audit.updatedDate),
        isModified: false
    };
};
